import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import contactUs from '../views/ContactUs.vue'
import companyProfile from '../views/CompanyProfile.vue'
import humanResources from '../views/HumanResources.vue'
import productDisplay from '../views/ProductDisplay.vue'
import qualificationHonor from '../views/QualificationsHonors.vue'
import lvdai from '../components/lvdai.vue'
import lvtong from '../components/lvtong.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
   {
    path: '/contactUs',
    name: 'contactUs',
    component: contactUs
  },
  {
    path: '/companyProfile',
    name: 'companyProfile',
    component: companyProfile
  },
  {
    path: '/humanResources',
    name: 'humanResources',
    component: humanResources
  },
  {
    path: '/productDisplay',
    name: 'productDisplay',
    component: productDisplay, 
  },
  {
    path: '/qualificationHonor',
    name: 'qualificationHonor',
    component: qualificationHonor
  },
  {
    path:'/lvdai',
    name:'lvdai',
    component:lvdai
  },
  {
    path:'/lvtong',
    name:'lvtong',
    component:lvtong
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
